
export default {
  name: 'VsTableValue',
  inheritAttrs: false,
  inject: ['table'],
  props: {
    value: {
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    $row() {
      return this.$parent.$el.parentNode
    }
  }
}
